import { extractData, extractLinks } from '@/libs/backend/apimapper';
import { HOROSCOPES_TYPES_SET_TYPES, HOROSCOPES_TYPES_GET_TYPES, HOROSCOPES_TYPES_LOAD_TYPES } from '@/store/constants';

const state = {
    horoscopeTypes: []
};

const actions = {
    [HOROSCOPES_TYPES_LOAD_TYPES]: async (context, payload) => {
        {
            const dataToStore = (sourceData) => {
                context.commit(HOROSCOPES_TYPES_SET_TYPES, sourceData);
            };

            try {
                const horoscopeTypes = await context.dispatch('backendTalker', {
                    request: 'horoscopeTypesList',
                    query: payload.query
                });

                if (!horoscopeTypes) {
                    return Promise.reject('Incorrect horoscope types data from backend');
                }

                if (payload.metaData) {
                    dataToStore(extractData(horoscopeTypes.data));
                    return extractLinks(horoscopeTypes.data)
                } else {
                    dataToStore(horoscopeTypes.data)
                }
            } catch (err) {
                return Promise.reject(err);
            }
        }
    }
};

const mutations = {
    [HOROSCOPES_TYPES_SET_TYPES]: (state, payload) => {
        state.horoscopeTypes = payload;
    },
};

const getters = {
    [HOROSCOPES_TYPES_GET_TYPES]: state => state.horoscopeTypes,
};

export default {
    state,
    actions,
    mutations,
    getters,
};